/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketsedittype2Inputs */

const en_ticketsedittype2 = /** @type {(inputs: Ticketsedittype2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit ticket type`)
};

const de_ticketsedittype2 = /** @type {(inputs: Ticketsedittype2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ticketart bearbeiten`)
};

/**
* | output |
* | --- |
* | "Edit ticket type" |
*
* @param {Ticketsedittype2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketsedittype2 = /** @type {((inputs?: Ticketsedittype2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketsedittype2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketsedittype2(inputs)
	return de_ticketsedittype2(inputs)
});
export { ticketsedittype2 as "ticketsEditType" }